import DepartmentsDataView from "./DepartmentsDataView";
import SearchDepartment from "./SearchDepartment";
import SydFilterProvider from "src/components/Common/UI/SydFilter/SydFilterContext";
import SydFilterView from "src/components/Common/UI/SydFilter/SydFilterView";


const defaultFilterData: IDepartmentSearchForm = {
  unID: "",
  description: "",
  sapCode: "",
  deleted: "",
  placeID: ""
}

const Departments = () => {
  return (
    <SydFilterProvider
      defaultFilterData={defaultFilterData}
    >
      <SydFilterView  title="Αναζήτηση Διεύθυνσης">
        <SearchDepartment />
      </SydFilterView>

      <DepartmentsDataView />
    </SydFilterProvider>
  )
}

export default Departments;